import React from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import { useToast } from '@zet/common/components/toast'
import {
  B1,
  B2,
  B5,
  BottomSheet,
  Button,
  Input,
  Stack,
} from '@zet/design-system'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { Controller, useForm } from 'react-hook-form'
import z from 'zod'

import { useUpdateUserProfileDetails } from '../../../../../apps/zet-app/src/api/user/hooks'

const emailValidationSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Invalid email address' }),
})

const MissingEmail = ({ isVisible, onClose }) => {
  const { data } = useUserContext()
  const { mutate, isLoading } = useUpdateUserProfileDetails()
  const toast = useToast()

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    resolver: zodResolver(emailValidationSchema),
    mode: 'onChange',
  })

  const handleProceed = () => {
    const { email } = getValues()
    const dataTobeSubmitted = {
      fullName: data?.fullName,
      email,
      occupation: data?.occupation,
      workExperience: data?.workExperience,
    }

    mutate(dataTobeSubmitted, {
      onSuccess: (response) => {
        if (response?.data?.message === 'success') {
          toast?.show({
            intent: 'success',
            heading: 'Email updated successfully',
            description: '',
            hideAfter: 1000,
          })
          onClose({
            success: true,
          })
        }
      },
    })
  }

  return (
    <BottomSheet
      visible={isVisible}
      disableBottomSheet={() =>
        onClose({
          success: false,
        })
      }
      sheetName="email_bottom_sheet"
    >
      <Stack className="w-[90%] mb-4 mt-2 self-center">
        <B1 className="text-center text-grays-80 font-bold ">
          {i18n.t('zetPrime.missingEmail')}
        </B1>
        <Stack className="mb-1 mt-3">
          <B2 className="text-grays-80 ml-1">Email</B2>
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                placeholder="Eg: ankush.singh@gmail.com"
                onChangeText={(value) => {
                  onChange(value)
                }}
                value={value}
                type={`${errors.email?.message ? 'error' : 'primary'}`}
                className=" mt-1 "
                onBlur={() => {
                  onBlur()
                }}
              />
            )}
            name="email"
          />
          {errors.email?.message ? (
            <Stack className="mt-2">
              <B5 className="text-error-100">{errors.email?.message}</B5>
            </Stack>
          ) : null}
        </Stack>
        <Stack className="mt-3">
          <Button
            intent={'primary'}
            size={'lg'}
            fullWidth={true}
            disabled={!isValid || isLoading}
            onPress={handleSubmit(handleProceed)}
            loading={isLoading}
          >
            Proceed
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default MissingEmail
